import React, { Component } from 'react';

import Scale from '../components/Scale';

import {
  createID,
  markerID
} from '../lib/createID';

import scrollToElement from 'scroll-to-element';

import {
  Map,
  Marker,
  Popup,
  TileLayer,
  Tooltip,
  Polygon
} from 'react-leaflet';

import {
  latLngBounds,
  divIcon
} from 'leaflet';

import 'leaflet/dist/leaflet.css';

import playIcon from '../imgs/play-circle.svg';
import pauseIcon from '../imgs/pause-circle.svg';
import recenterIcon from '../imgs/home.svg';

import { scaleLinear } from 'd3-scale';

import strftime from 'strftime';

import './Map.css';

import { API_URL } from '../lib/constants';

import { hamilton } from '../lib/hamilton';

const POLYGON = [
  [[90, 180], [90, -180], [-90, -180], [-90, 180]],
  hamilton
];
const CENTER = [39.18, -84.53];
const MINZ = 9;
const MAXZ = 19;
const BOUNDS = latLngBounds([
  [40, -85.5],
  [38.5, -83]
]);

// times are in milliseconds
const MILLI_IN_HOUR = 3.6e6;
const UPDATE_INTERVAL = 3e5;
const ANIMATION_TIME = 1e3;
const FORMAT_TIME_DISPLAY = '%a, %b %e, %I:%M %p';
const RAINVIEUX_BASE = `${API_URL}rainvieux/mosaic/cincy-1km-grid/duration/`;
const MAX_DOMAIN = 1;
const MIN_DOMAIN = 0;
const COLOR_SCALE = scaleLinear().domain([MIN_DOMAIN, MAX_DOMAIN]).range(['#FFFFFF','#7194C1']);

class Multimap extends Component {
  constructor() {
    super();
    this.state = {
      frame: 24,
      timeReference: [],
      animating: false,
      animationInterval: undefined,
      tileError: false,
      legendImgSrc: `${API_URL}rainvieux/scale/image/50/600.png`,
      updateInterval: undefined,
      zoom: 11,
      center: CENTER,
      small: undefined,
      boundingbox: undefined
    };
  }

  componentDidMount() {
    let defaultZoom = this.refs.getwidth.offsetWidth > 600 ? 10.75 : 9.75;
    this.setState({zoom: defaultZoom});

    let small = this.refs.getwidth.offsetWidth < 500 ? true : false;
    this.setState({small: small});

    let now = this.props.requesttime.getTime();
    let timeRef = this.generateTimeRefArray(now);
    this.setState({timeReference: timeRef});

    if (this.props.isreplay) {
      this.update();
    } else {
      let interval = setInterval(this.update, UPDATE_INTERVAL);
      this.setState({updateInterval: interval});
    }

    let img = new Image();
    img.src = this.state.legendImgSrc;
  }

  update = () => {
    let now = this.props.requesttime.getTime();
    let timeRef = this.generateTimeRefArray(now);
    this.setState({timeReference: timeRef});
  }

  componentWillUnmount() {
    this.killAnimation();
    clearInterval(this.state.updateInterval);
  }

  closeAllPopups() {
    this.refs.multimap.leafletElement.closePopup();
  }

  generateTimeRefArray(time) {
    let timeRef = [];
    for (let i = 24; i >= 0; i--) {
      let relativeTime = time - (i * MILLI_IN_HOUR);
      timeRef.push(relativeTime);
    }
    return timeRef;
  }

  handleRange = (event) => {
    let value = Number(event.target.value);
    if (this.state.animating) {
      this.killAnimation();
    }
    this.setState({frame: value});
  }

  handleAnimation = (event) => {
    if (this.state.animating) {
      this.killAnimation();
      return;
    }
    this.setState({animating: true});
    this.setState({animationInterval: setInterval(this.animate, ANIMATION_TIME)});
  }

  killAnimation() {
    this.setState({animating: false});
    clearInterval(this.state.animationInterval);
  }

  scrollTo(id) {
    let query = createID(id);
    let elem = document.querySelector('#' + query);
    elem.classList.add('hi');
    this.closeAllPopups();
    scrollToElement(elem, {
      offset: -16,
      duration: 300,
      ease: 'inOutSine'
    });
    setTimeout(function(){
      elem.classList.remove('hi');
    }, 5000)
  }

  animate = () => {
    if (this.props.mode !== 'radar') {
      this.killAnimation();
      return;
    }

    let frame = this.state.frame;
    let numFrames = this.state.timeReference.length;

    if (frame >= numFrames - 1) {
      frame = 0;
    } else {
      frame += 1;
    }

    this.setState({frame: frame});
  }

  reorientMap = () => {
    let map = this.refs.multimap.leafletElement;
    map.setView(this.state.center, this.state.zoom);
  }

  onTileError = () => {
    if (!this.state.tileError) {
      this.setState({tileError: true});
    }
  }

  render() {
    const RV_OPACITY = 0.75;
    let markers;
    let radar = [];
    let controls;
    let legend;

    //rainvieux duration is in minutes
    let duration = 1 * 60;

    //load the current frame for efficiency
    radar.push(
      <TileLayer
        url={`${RAINVIEUX_BASE}${this.state.timeReference[24]}/${duration}/tiles/{z}/{x}/{y}.png`}
        onTileerror={this.onTileError}
        opacity={this.state.frame === 24 && this.props.mode === 'radar' ? RV_OPACITY : 0}
        attribution='Vieux & Associates, Inc.'
        key={'24frameRadar'}
      />
    );
    // times to be displayed on map
    // start time is adjusted at start of mode condition
    let endTime = new Date(this.props.requesttime.getTime());
    let startTime = new Date(this.props.requesttime.getTime());

    if (this.props.mode === 'radar') {
      startTime.setHours(endTime.getHours() - 24); // radar data is last 24 hours of data
      // let map = this.refs.multimap.leafletElement;
      // console.log(map.getBounds());
      // console.log(map.getSize());
      for (var i = 0; i <= 23; i++) {
        radar.push(
          <TileLayer
            url={`${RAINVIEUX_BASE}${this.state.timeReference[i]}/${duration}/tiles/{z}/{x}/{y}.png`}
            onTileerror={this.onTileError}
            opacity={this.state.frame === i ? RV_OPACITY : 0}
            attribution='Vieux & Associates, Inc.'
            key={i + 'frameRadar'}
          />
        );
      }

      controls = (
        <div>
          <div className="animation-controls bg-white pa2">
            <div className="db tc text-info">
              {this.props.isreplay ? null : <h4>Last 24 Hours</h4>}
              Display Time: {strftime(FORMAT_TIME_DISPLAY, new Date(this.state.timeReference[this.state.frame]))}
            </div>
            <div className="db pt2 cf">
              <button className="fl w-20 pa0 pr2 ma0" onClick={this.handleAnimation}>
                <img src={this.state.animating ? pauseIcon : playIcon} alt="Play or Pause the animation."/>
              </button>
              <div className="fl w-80 help">
                <input type="range" min="0" max={this.state.timeReference.length - 1} value={this.state.frame} step="1" onChange={this.handleRange}/>
              </div>
            </div>
          </div>
          <div className="data-time">
            {strftime(FORMAT_TIME_DISPLAY, startTime)} - {strftime(FORMAT_TIME_DISPLAY, endTime)}
          </div>
          {this.state.tileError ? (<div className="tile-error">There was an error loading radar. Please refresh to try again.</div>) : null}
        </div>
      );

      legend = (
        <img className="legend" src={this.state.legendImgSrc} alt="RainVieux Scale Key"/>
      )
    } else if (this.props.gaugegeo && this.props.gaugerecent) {
      startTime.setHours(endTime.getHours() - 6); // gauge markers are showing last 6 hours of data

      markers = this.props.gaugegeo.map((g) => {
        let data = this.props.gaugerecent.find((d) => {
          return d.vaiId === g.id;
        });
        if (!data) return undefined;

        let iconSettings = {
          className: 'gauge',
          iconSize: [24, 24],
          html: `<div></div>`
        };
        let value = typeof data.sixHour === 'number' ? data.sixHour.toFixed(2) : 'N/A';
        let styles = COLOR_SCALE(value);
        if (value === 'N/A') {
          styles = COLOR_SCALE.range()[0];
        }
        let id = markerID(g.id);
        iconSettings.html = `<div class="dt b--black br-100 tc ba bw1 black marker" style="background-color: ${styles};" id="${id}"><span>${value}</span></div>`;
        let icon = new divIcon(iconSettings);

        let content;
        if (this.state.small) {
          content = (
            <span>{g.id}</span>
          );
        } else {
          let popupDetails;

          if (this.props.mode === 'gaugeRecent') {
            popupDetails = data.sums.map((s, i) => {
              return (
                <tr key={'sum'+i}>
                  <td width="50%" className="no-wrap align-r b">{s.hours}&nbsp;{i > 0 ? 'hours' : 'hour'}:</td>
                  <td width="50%" className="no-wrap align-l">{s.sum === null ? 'N/A' : s.sum}</td>
                </tr>
                // <div className="sums" key={'sum'+i}>
                //   <div className="w50p align-r b">{s.hours}&nbsp;{i > 0 ? 'hours' : 'hour'}: </div>
                //   <div className="w50p align-l">{s.sum === null ? 'N/A' : s.sum}</div>
                // </div>
              );
            });
          } else if (this.props.mode === 'gaugeDDF') {
            popupDetails = data.durations.seventytwo.map((s, i) => {
              let emptyData = {
                frequencyId: null,
                description: '-',
                depth: null
              };
              data.durations.twentyfour[i].categories.push(emptyData);
              data.durations.seventytwo[i].categories.push(emptyData);

              let cat24 = data.durations.twentyfour[i].categories.find((c24) => {
                return c24.frequencyId === data.durations.twentyfour[i].frequencyId;
              });

              let cat72 = data.durations.seventytwo[i].categories.find((c72) => {
                return c72.frequencyId === data.durations.seventytwo[i].frequencyId;
              });

              return (
                <tr key={'sum'+i}>
                  <td width="34%" className="no-wrap align-r">{s.description}:</td>
                  <td width="33%" className="no-wrap align-c">{cat24.description}</td>
                  <td width="33%" className="no-wrap align-c">{cat72.description}</td>
                </tr>
                // <div className="sums" key={'sum'+i}>
                //   <div className="w33p align-r">{s.description}: </div>
                //   <div className="w66p align-l">
                //     <span className="w50p">{cat24.description}</span>
                //     <span className="w50p">{cat72.description}</span>
                //   </div>
                // </div>
              );
            });

            let popupThead = (
              <tr key={'sum'+i}>
                <td width="34%" className="lh1 align-r b">Interval Time</td>
                <td width="33%" className="no-wrap align-c b">24hrs</td>
                <td width="33%" className="no-wrap align-c b">72hrs</td>
              </tr>
            );
            popupDetails.unshift(popupThead);
          }

          content = (
            <div>
              <Popup>
                <div>
                  <a href={'#gauge' + g.id} onClick={this.scrollTo.bind(this, g.id)} title="To Table Item">{g.name}</a>
                  <table cellSpacing="0"><tbody>{popupDetails}</tbody></table>
                </div>
              </Popup>
              <Tooltip direction='bottom' offset={[0, 8]} opacity={1} interactive={true} permanent>
                <span>{g.id}</span>
              </Tooltip>
            </div>
          );
        }

        return (
          <Marker icon={icon} position={[g.lat, g.lng]} key={g.id}>
            {content}
          </Marker>
        )
      });

      controls = (
        <div>
          <div className="data-time">
            {strftime(FORMAT_TIME_DISPLAY, startTime)} - {strftime(FORMAT_TIME_DISPLAY, endTime)}
          </div>
        </div>
      );

      legend =  (
        <Scale startcolor={COLOR_SCALE.range()[0]} endcolor={COLOR_SCALE.range()[1]} min={COLOR_SCALE.domain()[0]} max={COLOR_SCALE.domain()[1]} small={this.state.small} />
      );
    }

    return (
      <section ref="getwidth" className="map-section">
        <a href="#skip-map" className="accessible">Skip the map section. Go to navigation.</a>
        <Map
          ref="multimap"
          id="map"
          center={this.state.center}
          zoom={this.state.zoom}
          scrollWheelZoom={false}
          maxBounds={BOUNDS}
          minZoom={MINZ}
          maxZoom={MAXZ}
          zoomSnap={0}
          zoomDelta={0.5}
          preferCanvas={true}
          >
          <TileLayer
            url='https://api.mapbox.com/styles/v1/mapbox/traffic-day-v2/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGp2aWV1eCIsImEiOiJjajV5MXQ2NHMwYWM5Mnd0YnAyNHFmOW11In0.lOl5O3KTdAR2tjC9YZ_yZg'
            attribution='© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <Polygon
            positions={POLYGON}
            fillColor="#000000"
            fillOpacity="0.54"
            stroke={false}
            interactive={false}
          />
          {radar}
          {markers}
        </Map>
        <button className="pa0 center-button input-reset bg-white reset" onClick={this.reorientMap}>
          <img className="db" src={recenterIcon} alt="Home icon to reorient map."/>
        </button>
        {controls}
        {legend}
      </section>
    );
  }
}

export default Multimap;



// WEBPACK FOOTER //
// ./src/components/Map.js